import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';

import { routerTransition } from '../app.router.animations';

@Component({
    selector: 'app-not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.Default,
    animations: [routerTransition()],
    host: { '[@routerTransition]': '' }
})
export class NotFoundComponent implements OnInit {
    constructor() {
        //
    }

    ngOnInit(): void {

    }
}
